<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.manufacturers')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <NozzleManufacturerForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import NozzleManufacturerForm from '../../components/nozzlemanufacturer/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'NozzleManufacturer';

const { mapFields } = createHelpers({
  getterType: 'nozzlemanufacturer/getField',
  mutationType: 'nozzlemanufacturer/updateField'
});

export default {
  name: 'NozzleManufacturerCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleManufacturerForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('nozzlemanufacturer', ['create', 'reset'])
  }
};
</script>
